import { render, staticRenderFns } from "./InputUploader.vue?vue&type=template&id=5e245ae7&"
import script from "./InputUploader.vue?vue&type=script&lang=js&"
export * from "./InputUploader.vue?vue&type=script&lang=js&"
import style0 from "./InputUploader.vue?vue&type=style&index=0&id=5e245ae7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports